export default {
  tabPremium: {
    id: 'review-photos-guidance-drawer-tab-premium',
    defaultMessage: 'Premium',
  },
  tabFlawless: {
    id: 'review-photos-guidance-drawer-tab-flawless',
    defaultMessage: 'Excellent',
  },
  tabVeryGood: {
    id: 'review-photos-guidance-drawer-tab-very-good',
    defaultMessage: 'Good',
  },
  tabEco: {
    id: 'review-photos-guidance-drawer-tab-eco',
    defaultMessage: 'Fair',
  },
  tabsLabel: {
    id: 'review-photos-guidance-drawer-tabs-label',
    defaultMessage: 'Reviews photos by condition',
  },
  carouselController: {
    id: 'review-photos-guidance-drawer-carousel-controller',
    defaultMessage: 'Photo carousel controller',
  },
  alternativeNext: {
    id: 'review-photos-guidance-drawer-next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'review-photos-guidance-drawer-previous',
    defaultMessage: 'Previous',
  },
  defaultCardTitle: {
    id: 'review-photos-guidance-drawer-default-card-title',
    defaultMessage: '{grade} condition',
  },
  reviewImageTag: {
    id: 'review-photos-guidance-drawer-review-image-tag',
    defaultMessage: 'Review image',
  },
  seeAllReviews: {
    id: 'review-photos-guidance-drawer-see-all-reviews',
    defaultMessage: 'See all reviews for {grade}',
  },
  defaultCardDescriptionPremium: {
    id: 'review-photos-guidance-drawer-default-card-description-premium',
    defaultMessage:
      'Example photo of what you might see on the body and screen.',
  },
  defaultCardDescriptionFlawless: {
    id: 'review-photos-guidance-drawer-default-card-description-flawless',
    defaultMessage:
      'Example photo of what you might see on the body and screen.',
  },
  defaultCardDescriptionVeryGood: {
    id: 'review-photos-guidance-drawer-default-card-description-very-good',
    defaultMessage:
      'Example photo of what you might see on the body and screen.',
  },
  defaultCardDescriptionEco: {
    id: 'review-photos-guidance-drawer-default-card-description-eco',
    defaultMessage:
      'Example photo of what you might see on the body and screen.',
  },
  newDefaultCardTitlePremium: {
    id: 'review-photos-guidance-drawer-new-default-card-title-premium',
    defaultMessage: 'What "Premium" means',
  },
  newDefaultCardTitleFlawless: {
    id: 'review-photos-guidance-drawer-new-default-card-title-flawless',
    defaultMessage: 'What "Excellent condition" means',
  },
  newDefaultCardTitleVeryGood: {
    id: 'review-photos-guidance-drawer-new-default-card-title-very-good',
    defaultMessage: 'What "Good condition" means',
  },
  newDefaultCardTitleEco: {
    id: 'review-photos-guidance-drawer-new-default-card-title-eco',
    defaultMessage: 'What "Fair condition" means',
  },
  newDefaultCardSubtitlePremium: {
    id: 'review-photos-guidance-drawer-new-default-card-subtitle-premium',
    defaultMessage: 'Our top cosmetic condition plus more.',
  },
  newDefaultCardSubtitleFlawless: {
    id: 'review-photos-guidance-drawer-new-default-card-subtitle-flawless',
    defaultMessage: 'Close to perfect without a magnifying glass. ',
  },
  newDefaultCardSubtitleVeryGood: {
    id: 'review-photos-guidance-drawer-new-default-card-subtitle-very-good',
    defaultMessage: 'How it’ll look anyways after some use. ',
  },
  newDefaultCardSubtitleEco: {
    id: 'review-photos-guidance-drawer-new-default-card-subtitle-eco',
    defaultMessage: 'Perfect if you plan to cover it with a case.',
  },
  newDefaultCardHowItLooksLabel: {
    id: 'review-photos-guidance-drawer-new-default-card-how-it-looks-label',
    defaultMessage: 'How it looks:',
  },
  newDefaultCardBatteryLabel: {
    id: 'review-photos-guidance-drawer-new-default-card-battery-label',
    defaultMessage: 'Battery:',
  },
  newDefaultCardQualityTitle: {
    id: 'review-photos-guidance-drawer-new-default-card-quality-title',
    defaultMessage: 'Quality, promised.',
  },
  newDefaultCardQualityDescription: {
    id: 'review-photos-guidance-drawer-new-default-card-quality-description',
    defaultMessage:
      'Every device is guaranteed 100% functional regardless of condition. You also get 1-year warranty and easy 30-day returns.',
  },
  newDefaultCardHowItLooksPremium: {
    id: 'review-photos-guidance-drawer-new-default-card-how-it-looks-premium',
    defaultMessage:
      'No visible signs of use on screen or body, indistinguishable from a new device.',
  },
  newDefaultCardHowItLooksFlawless: {
    id: 'review-photos-guidance-drawer-new-default-card-how-it-looks-flawless',
    defaultMessage:
      'Minimal signs of use on screen and body with barely noticeable cosmetic wear.',
  },
  newDefaultCardHowItLooksVeryGood: {
    id: 'review-photos-guidance-drawer-new-default-card-how-it-looks-very-good',
    defaultMessage:
      'Light signs of use on screen and body with minor cosmetic wear such as faint scratches or scuffs.',
  },
  newDefaultCardHowItLooksEco: {
    id: 'review-photos-guidance-drawer-new-default-card-how-it-looks-eco',
    defaultMessage:
      'Signs of use on screen and body with visible cosmetic wear such as surface scratches or scuffs.',
  },
  newDefaultCardBatteryPremium: {
    id: 'review-photos-guidance-drawer-new-default-card-battery-premium',
    defaultMessage: '90% or more battery health and 100% charge capacity. ',
  },
  newDefaultCardBatteryFlawless: {
    id: 'review-photos-guidance-drawer-new-default-card-battery-flawless',
    defaultMessage:
      'Meets industry standards at 80% or more battery health and 100% charge capacity. ',
  },
  newDefaultCardBatteryVeryGood: {
    id: 'review-photos-guidance-drawer-new-default-card-battery-very-good',
    defaultMessage:
      'Meets industry standards at 80% or more battery health and 100% charge capacity. ',
  },
  newDefaultCardBatteryEco: {
    id: 'review-photos-guidance-drawer-new-default-card-battery-eco',
    defaultMessage:
      'Meets industry standards at 80% or more battery health and 100% charge capacity.',
  },
}
